// extracted by mini-css-extract-plugin
module.exports = {"container":"_27v2g","arrow":"_2Gium","page":"_1Q-RS","active":"_2dJ2P"};